import React from "react";
import { observer } from "mobx-react-lite";
import { useGlobalStore } from "@/store/hooks";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import AppSubscriptionContainer from "@/scenes/setting/Shop/AppSubscription/components/AppSubscriptionContainer";

interface SubscriptionExpiredProps {}

/**
 * 发货易店铺订购过期页面
 */
const SubscriptionExpired: React.FC<SubscriptionExpiredProps> = observer(function (props) {
    const { shopId } = useParams<{ shopId: string }>();
    const globalStore = useGlobalStore();
    const shop = globalStore.shopMapping.get(Number(shopId));

    if (!shop) {
        return <div>AppSubscription出错了，请联系客服反馈</div>;
    }

    return (
        <div>
            <AppSubscriptionContainer shop={shop} showExpiredTip />

            <Link to={`/subscription/order/list/${shopId}`} className="mt40 inline-block" target="_blank">
                查看{shop.name}订购记录
            </Link>
        </div>
    );
});

export default SubscriptionExpired;
